// delLists/submitLists/state.js

export const submitsInitialState = {
  items: [],
  tableType: "submits",
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  loading: false,
  error: null,
  needsUpdate: false,
  selectedSubmit: null,
  selectedSubmitIds: [],
};
